// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Dashboard Page Styles */

.admin-dashboard-page {
    animation: fadeIn 0.5s ease;
    background: #f8fafc;
    width: 100%;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Welcome Header */
.admin-welcome-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
}

.admin-welcome-header h1 {
    font-size: 2rem;
    font-weight: 700;
    color: #1a202c;
    margin: 0 0 0.5rem 0;
}

.admin-subtitle {
    color: #718096;
    font-size: 1rem;
    margin: 0;
}

/* Quick Actions */
.admin-quick-actions {
    display: flex;
    gap: 1rem;
}

.quick-action-btn {
    padding: 0.875rem 1.5rem;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    border: none;
    font-size: 0.95rem;
}

.quick-action-btn.primary {
    background: linear-gradient(135deg, #667eea 0%, #764 ba2 100%);
    color: white;
}

.quick-action-btn.primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

.quick-action-btn.secondary {
    background: white;
    color: #667eea;
    border: 2px solid #667eea;
}

.quick-action-btn.secondary:hover {
    background: #667eea;
    color: white;
}

/* Stats Grid */
.admin-stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-gap: 1.5rem;
    gap: 1.5rem;
    margin-bottom: 2rem;
}

.stat-card {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    display: flex;
    gap: 1.25rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.stat-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
}

.stat-card.blue::before {
    background: #4299e1;
}

.stat-card.green::before {
    background: #48bb78;
}

.stat-card.orange::before {
    background: #ed8936;
}

.stat-card.purple::before {
    background: #9f7aea;
}

.stat-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.stat-icon {
    width: 64px;
    height: 64px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.stat-card.blue .stat-icon {
    background: linear-gradient(135deg, #4299e1, #3182ce);
    color: white;
}

.stat-card.green .stat-icon {
    background: linear-gradient(135deg, #48bb78, #38a169);
    color: white;
}

.stat-card.orange .stat-icon {
    background: linear-gradient(135deg, #ed8936, #dd6b20);
    color: white;
}

.stat-card.purple .stat-icon {
    background: linear-gradient(135deg, #9f7aea, #805ad5);
    color: white;
}

.stat-content h3 {
    font-size: 2rem;
    font-weight: 700;
    color: #1a202c;
    margin: 0 0 0.25rem 0;
}

.stat-content p {
    color: #718096;
    font-size: 0.9rem;
    margin: 0 0 0.5rem 0;
}

.stat-change {
    font-size: 0.85rem;
    font-weight: 600;
}

.stat-change.positive {
    color: #48bb78;
}

/* Content Grid */
.admin-content-grid {
    display: grid;
    grid-gap: 1.5rem;
    gap: 1.5rem;
}

/* Admin Card */
.admin-card {
    background: white;
    border-radius: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    overflow: hidden;
}

.admin-card-header {
    padding: 1.5rem;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.admin-card-header h2 {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1a202c;
    margin: 0;
}

.view-all-btn {
    background: none;
    border: none;
    color: #667eea;
    font-weight: 600;
    cursor: pointer;
    transition: color 0.3s ease;
    font-size: 0.9rem;
}

.view-all-btn:hover {
    color: #764ba2;
}

/* Table Styles */
.admin-table-container {
    overflow-x: auto;
}

.admin-table {
    width: 100%;
    border-collapse: collapse;
}

.admin-table thead {
    background: #f7fafc;
}

.admin-table th {
    padding: 1rem 1.5rem;
    text-align: left;
    font-weight: 600;
    font-size: 0.85rem;
    color: #4a5568;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.admin-table tbody tr {
    border-bottom: 1px solid #e2e8f0;
    transition: background 0.3s ease;
}

.admin-table tbody tr:hover {
    background: #f7fafc;
}

.admin-table td {
    padding: 1.25rem 1.5rem;
    color: #2d3748;
    font-size: 0.95rem;
}

.user-name {
    font-weight: 600;
    color: #1a202c;
}

.user-email {
    color: #718096;
}

.user-date {
    color: #a0aec0;
    font-size: 0.9rem;
}

.loan-amount {
    font-weight: 700;
    color: #1a202c;
}

/* Status Badges */
.status-badge {
    padding: 0.375rem 0.875rem;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: capitalize;
    display: inline-block;
}

.status-badge.status-success {
    background: #c6f6d5;
    color: #22543d;
}

.status-badge.status-warning {
    background: #fef5e7;
    color: #b7791f;
}

.status-badge.status-danger {
    background: #fed7d7;
    color: #742a2a;
}

/* Responsive */
@media (max-width: 1200px) {
    .admin-stats-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {
    .admin-welcome-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
    }

    .admin-quick-actions {
        width: 100%;
    }

    .quick-action-btn {
        flex: 1 1;
    }

    .admin-stats-grid {
        grid-template-columns: 1fr;
    }

    .stat-card {
        padding: 1.25rem;
    }

    .stat-icon {
        width: 56px;
        height: 56px;
    }

    .stat-content h3 {
        font-size: 1.75rem;
    }

    .admin-card-header {
        padding: 1.25rem;
    }

    .admin-table th,
    .admin-table td {
        padding: 1rem;
        font-size: 0.85rem;
    }
}

@media (max-width: 480px) {
    .admin-welcome-header h1 {
        font-size: 1.5rem;
    }

    .admin-subtitle {
        font-size: 0.9rem;
    }

    .quick-action-btn {
        padding: 0.75rem 1rem;
        font-size: 0.85rem;
    }

    .admin-table {
        font-size: 0.8rem;
    }

    .admin-table th,
    .admin-table td {
        padding: 0.75rem;
    }

    .user-email,
    .user-date {
        font-size: 0.75rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/AdminDashboardPage.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,SAAS;AACb;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,8DAA8D;IAC9D,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,2DAA2D;IAC3D,gBAAW;IAAX,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,YAAY;IACZ,yCAAyC;IACzC,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,qDAAqD;IACrD,YAAY;AAChB;;AAEA;IACI,qDAAqD;IACrD,YAAY;AAChB;;AAEA;IACI,qDAAqD;IACrD,YAAY;AAChB;;AAEA;IACI,qDAAqD;IACrD,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,gBAAW;IAAX,WAAW;AACf;;AAEA,eAAe;AACf;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAO;IACX;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,aAAa;QACb,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,kBAAkB;IACtB;AACJ","sourcesContent":["/* Admin Dashboard Page Styles */\n\n.admin-dashboard-page {\n    animation: fadeIn 0.5s ease;\n    background: #f8fafc;\n    width: 100%;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Welcome Header */\n.admin-welcome-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n}\n\n.admin-welcome-header h1 {\n    font-size: 2rem;\n    font-weight: 700;\n    color: #1a202c;\n    margin: 0 0 0.5rem 0;\n}\n\n.admin-subtitle {\n    color: #718096;\n    font-size: 1rem;\n    margin: 0;\n}\n\n/* Quick Actions */\n.admin-quick-actions {\n    display: flex;\n    gap: 1rem;\n}\n\n.quick-action-btn {\n    padding: 0.875rem 1.5rem;\n    border-radius: 10px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    border: none;\n    font-size: 0.95rem;\n}\n\n.quick-action-btn.primary {\n    background: linear-gradient(135deg, #667eea 0%, #764 ba2 100%);\n    color: white;\n}\n\n.quick-action-btn.primary:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);\n}\n\n.quick-action-btn.secondary {\n    background: white;\n    color: #667eea;\n    border: 2px solid #667eea;\n}\n\n.quick-action-btn.secondary:hover {\n    background: #667eea;\n    color: white;\n}\n\n/* Stats Grid */\n.admin-stats-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 1.5rem;\n    margin-bottom: 2rem;\n}\n\n.stat-card {\n    background: white;\n    border-radius: 16px;\n    padding: 1.5rem;\n    display: flex;\n    gap: 1.25rem;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n    transition: all 0.3s ease;\n    position: relative;\n    overflow: hidden;\n}\n\n.stat-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 4px;\n    height: 100%;\n}\n\n.stat-card.blue::before {\n    background: #4299e1;\n}\n\n.stat-card.green::before {\n    background: #48bb78;\n}\n\n.stat-card.orange::before {\n    background: #ed8936;\n}\n\n.stat-card.purple::before {\n    background: #9f7aea;\n}\n\n.stat-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n}\n\n.stat-icon {\n    width: 64px;\n    height: 64px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.stat-card.blue .stat-icon {\n    background: linear-gradient(135deg, #4299e1, #3182ce);\n    color: white;\n}\n\n.stat-card.green .stat-icon {\n    background: linear-gradient(135deg, #48bb78, #38a169);\n    color: white;\n}\n\n.stat-card.orange .stat-icon {\n    background: linear-gradient(135deg, #ed8936, #dd6b20);\n    color: white;\n}\n\n.stat-card.purple .stat-icon {\n    background: linear-gradient(135deg, #9f7aea, #805ad5);\n    color: white;\n}\n\n.stat-content h3 {\n    font-size: 2rem;\n    font-weight: 700;\n    color: #1a202c;\n    margin: 0 0 0.25rem 0;\n}\n\n.stat-content p {\n    color: #718096;\n    font-size: 0.9rem;\n    margin: 0 0 0.5rem 0;\n}\n\n.stat-change {\n    font-size: 0.85rem;\n    font-weight: 600;\n}\n\n.stat-change.positive {\n    color: #48bb78;\n}\n\n/* Content Grid */\n.admin-content-grid {\n    display: grid;\n    gap: 1.5rem;\n}\n\n/* Admin Card */\n.admin-card {\n    background: white;\n    border-radius: 16px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n    overflow: hidden;\n}\n\n.admin-card-header {\n    padding: 1.5rem;\n    border-bottom: 1px solid #e2e8f0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.admin-card-header h2 {\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: #1a202c;\n    margin: 0;\n}\n\n.view-all-btn {\n    background: none;\n    border: none;\n    color: #667eea;\n    font-weight: 600;\n    cursor: pointer;\n    transition: color 0.3s ease;\n    font-size: 0.9rem;\n}\n\n.view-all-btn:hover {\n    color: #764ba2;\n}\n\n/* Table Styles */\n.admin-table-container {\n    overflow-x: auto;\n}\n\n.admin-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.admin-table thead {\n    background: #f7fafc;\n}\n\n.admin-table th {\n    padding: 1rem 1.5rem;\n    text-align: left;\n    font-weight: 600;\n    font-size: 0.85rem;\n    color: #4a5568;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.admin-table tbody tr {\n    border-bottom: 1px solid #e2e8f0;\n    transition: background 0.3s ease;\n}\n\n.admin-table tbody tr:hover {\n    background: #f7fafc;\n}\n\n.admin-table td {\n    padding: 1.25rem 1.5rem;\n    color: #2d3748;\n    font-size: 0.95rem;\n}\n\n.user-name {\n    font-weight: 600;\n    color: #1a202c;\n}\n\n.user-email {\n    color: #718096;\n}\n\n.user-date {\n    color: #a0aec0;\n    font-size: 0.9rem;\n}\n\n.loan-amount {\n    font-weight: 700;\n    color: #1a202c;\n}\n\n/* Status Badges */\n.status-badge {\n    padding: 0.375rem 0.875rem;\n    border-radius: 20px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    text-transform: capitalize;\n    display: inline-block;\n}\n\n.status-badge.status-success {\n    background: #c6f6d5;\n    color: #22543d;\n}\n\n.status-badge.status-warning {\n    background: #fef5e7;\n    color: #b7791f;\n}\n\n.status-badge.status-danger {\n    background: #fed7d7;\n    color: #742a2a;\n}\n\n/* Responsive */\n@media (max-width: 1200px) {\n    .admin-stats-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 768px) {\n    .admin-welcome-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 1rem;\n    }\n\n    .admin-quick-actions {\n        width: 100%;\n    }\n\n    .quick-action-btn {\n        flex: 1;\n    }\n\n    .admin-stats-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .stat-card {\n        padding: 1.25rem;\n    }\n\n    .stat-icon {\n        width: 56px;\n        height: 56px;\n    }\n\n    .stat-content h3 {\n        font-size: 1.75rem;\n    }\n\n    .admin-card-header {\n        padding: 1.25rem;\n    }\n\n    .admin-table th,\n    .admin-table td {\n        padding: 1rem;\n        font-size: 0.85rem;\n    }\n}\n\n@media (max-width: 480px) {\n    .admin-welcome-header h1 {\n        font-size: 1.5rem;\n    }\n\n    .admin-subtitle {\n        font-size: 0.9rem;\n    }\n\n    .quick-action-btn {\n        padding: 0.75rem 1rem;\n        font-size: 0.85rem;\n    }\n\n    .admin-table {\n        font-size: 0.8rem;\n    }\n\n    .admin-table th,\n    .admin-table td {\n        padding: 0.75rem;\n    }\n\n    .user-email,\n    .user-date {\n        font-size: 0.75rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
